<template>
  <theme-provider :theme="theme">
    <div id="app" :class="[navType]">
      <MainNav2
        v-if="
          routeName &&
          routeName.indexOf('account') === -1 &&
          routeName.indexOf('Submitted') === -1 &&
          !routeName.includes('review thanks')
        "
        :toggle-nav="toggleNav"
      ></MainNav2>

      <div v-if="fatalError" class="app-content">
        <div class="global-fallback">
          <div class="fallback-card">
            <h2>Something went wrong</h2>

            <p>
              We’re having trouble loading this page right now. Please try again
              in a moment. If the problem continues, please contact us via
              <span class="intercom-link" @click="openInterCom">Intercom.</span>
            </p>

            <div class="actions">
              <button class="reloadButton" @click="reload">Reload</button>
            </div>
          </div>
        </div>
      </div>
      <keep-alive v-else include="cachedPages">
        <component :is="template">
          <RouterView />
        </component>
      </keep-alive>

      <Footer
        v-if="
          routeName &&
          routeName.indexOf('Submitted') === -1 &&
          !routeName.includes('review thanks')
        "
      ></Footer>
    </div>
  </theme-provider>
</template>

<script>
import { ThemeProvider } from 'vue3-styled-components'
import { mapActions } from 'vuex'

import * as theme from './components/ui/styled/theme'
// import MainNav from '@/components/MainNav'
import MainNav2 from '@/components/main_nav/main_nav_v2/Nav.vue'
import Footer from '@/components/Footer'

const defaultLayout = 'default'

export default {
  name: 'App',
  components: { 'theme-provider': ThemeProvider, MainNav2, Footer },
  data() {
    return {
      cachedPages: ['vunue booking details'],
      navType: 'Sticky_Bar',
      theme: theme.light,
      fatalError: null,
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    template() {
      return 'template-' + (this.$route.meta.template || defaultLayout)
    },
    isLocalDev() {
      return (
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1'
      )
    },
  },
  mounted() {
    window.addEventListener('unhandledrejection', this.handlePromiseError)
    window.addEventListener('error', this.handleWindowError)
  },

  methods: {
    ...mapActions('ui', ['toggleNav']),
    reload() {
      window.location.reload()
    },

    openInterCom() {
      window.Intercom('show')
    },

    isConnectivityError(err) {
      const status =
        err?.statusCode ||
        err?.status ||
        err?.response?.status ||
        err?.networkError?.statusCode ||
        err?.networkError?.status ||
        null
      if ([502, 503, 504].includes(status)) return true

      const msg = String(
        err?.message || err?.reason?.message || err?.reason || err || '',
      ).toLowerCase()

      const patterns = [
        'failed to fetch',
        'networkerror when attempting to fetch resource',
        'load failed',
        'net::err_failed',
        'net::err_connection_refused',
        'net::err_connection_reset',
        'net::err_connection_timed_out',
        'net::err_name_not_resolved',
        'the internet connection appears to be offline',
        'cors',
      ]

      return patterns.some((p) => msg.includes(p))
    },

    handlePromiseError(e) {
      if (this.isLocalDev) return

      const reason = e?.reason

      if (this.isConnectivityError(reason)) {
        this.fatalError = reason
      }
    },

    handleWindowError(e) {
      if (this.isLocalDev) return
      const err = e?.error || e

      if (this.isConnectivityError(err)) {
        this.fatalError = err
      }
    },
  },
}
</script>

<style lang="scss">
/* SETUP */
@import '~sanitize.css';

/* MAIN STYLES DEFINITION */
@import './styles/style.scss';

/* Rest of your styles... */
</style>

<style scoped lang="scss">
.reloadButton {
  display: inline-block;
  padding: 12px 32px;

  background-color: #3b76ad;
  color: #ffffff;

  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  text-align: center;

  border: none;
  border-radius: 8px;
  cursor: pointer;

  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  transition:
    background-color 0.2s ease,
    transform 0.1s ease;
}
.intercom-link {
  text-decoration: underline;
  cursor: pointer;
  color: #3b76ad;
}
.main_menu_items {
  align-items: center;

  & > * {
    padding: 0 0.5rem;
  }
}

// PAGE-SPECIFIC STYLES
// Notification Pages
.Forbidden,
.BadRequest,
.NotFound {
  text-align: center;
  padding-top: 4rem;
  /deep/ .page-title {
    margin-bottom: 2rem;
  }
}

.app-content {
  min-height: calc(100vh - 140px);
  display: flex;
}

.global-fallback {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fallback-card {
  max-width: 520px;
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow:
    0 -6px 12px rgba(0, 0, 0, 0.12),
    0 12px 32px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.actions {
  margin-top: 16px;
}

.actions button {
  margin: 0 6px;
}
</style>
